// utils/notify.js
import Vue from 'vue'

export const notifyBus = new Vue()

export const notifyStore = {
    show: true,
    audioOn: true,
    types: {
        '注册用户': { show: true, audioOn: true },
        '绑定手机号': { show: true, audioOn: true },
        '用户下单': { show: true, audioOn: true },
        '陪玩_准备下单': { show: true, audioOn: true },
        '城市合作': { show: true, audioOn: true }, // ← 新增
    }
}

// 放置对应 mp3 到你的静态资源目录；没有则会回退到默认音
export const AUDIO_MAP = {
    '注册用户': './NewUser.mp3',
    '绑定手机号': './NewPhone.mp3',
    '用户下单': './NewOrder.mp3',
    '陪玩_准备下单': './PreOrder.mp3',
    '城市合作': './CityPartner.mp3', // ← 新增
}
